import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
  templates: [
    {
      id: 1,
      thumbnail: 'https://cdn.cf.masterwizr.com/Group_1321314336_ivqyts.png',
      numberOfItems: 1
    },
    {
      id: 4,
      thumbnail: 'https://cdn.cf.masterwizr.com/Group_40582_m4wkth.png',
      numberOfItems: 2
    },
    {
      id: 5,
      thumbnail: 'https://cdn.cf.masterwizr.com/Group_40583_ntfzck.png',
      numberOfItems: 3
    },
    {
      id: 6,
      thumbnail: 'https://cdn.cf.masterwizr.com/Group_40584_tmf4rt.png',
      numberOfItems: 3,
      numberOfRows: 2
    },
      {
      id: 7,
      thumbnail: 'https://cdn.cf.masterwizr.com/Group_1321314342_mfvsnr.png',
      numberOfItems: 2,
      numberOfRows: 2
    },
      {
      id: 8,
      thumbnail: 'https://cdn.cf.masterwizr.com/Group_1321314338_ipbmt7.png',
      numberOfItems: 4
    }
  ]
};

const templateSlice = createSlice({
  name: 'templates',
  initialState,
  reducers: {
    updateTemplate: (state, action) => {
      const { id, data } = action.payload;
      const index = state.templates.findIndex((template) => template.id === id);
      if (index !== -1) {
        state.templates[index] = { ...state.templates[index], ...data };
      }
    }
  }
});

export const { updateTemplate } = templateSlice.actions;
export default templateSlice.reducer;
